import React from 'react';
import { BarChart2, Users, Mail, DollarSign, Target, Activity, ChevronDown } from 'lucide-react';
export function Sidebar() {
  return <div className="w-64 bg-[#1B3A4B] min-h-screen flex flex-col text-slate-300 text-sm font-medium" data-id="element-161">
      <div className="p-6" data-id="element-162">{/* Placeholder for top spacing if needed */}</div>

      <div className="flex-1 overflow-y-auto" data-id="element-163">
        <div className="mb-6" data-id="element-164">
          <div className="px-6 py-2 text-xs font-bold text-slate-500 uppercase tracking-wider flex justify-between items-center cursor-pointer hover:text-slate-300" data-id="element-165">
            Donor Lifecycle
            <ChevronDown size={14} data-id="element-166" />
          </div>
          <div className="px-6 py-2.5 hover:bg-white/5 cursor-pointer transition-colors" data-id="element-167">
            Acquisition & Retention
          </div>
        </div>

        <div className="mb-6" data-id="element-168">
          <div className="px-6 py-2 text-xs font-bold text-slate-500 uppercase tracking-wider flex justify-between items-center cursor-pointer hover:text-slate-300" data-id="element-169">
            <div className="flex items-center gap-2" data-id="element-170">
              <div className="w-1.5 h-1.5 rounded-full bg-[#1A8B9D]" data-id="element-171"></div>
              Where From?
            </div>
            <ChevronDown size={14} data-id="element-172" />
          </div>

          <div className="mt-2" data-id="element-173">
            <div className="px-6 py-2 text-[10px] font-bold text-slate-500 uppercase tracking-wider" data-id="element-174">
              Channel & Campaign Performance
            </div>
            <div className="px-6 py-2.5 hover:bg-white/5 cursor-pointer transition-colors" data-id="element-175">
              Performance Explorer
            </div>
            <div className="px-6 py-2.5 hover:bg-white/5 cursor-pointer transition-colors" data-id="element-176">
              Channel Synergy
            </div>
          </div>
        </div>

        <div className="mb-6" data-id="element-177">
          <div className="px-6 py-2 text-[10px] font-bold text-slate-500 uppercase tracking-wider" data-id="element-178">
            A/B Testing
          </div>
          <div className="px-6 py-2.5 bg-[#1A8B9D] text-white cursor-pointer border-l-4 border-white" data-id="element-179">
            Experiment Results
          </div>
          <div className="px-6 py-2.5 hover:bg-white/5 cursor-pointer transition-colors" data-id="element-180">
            Active Experiments
          </div>
        </div>

        <div className="mb-6" data-id="element-181">
          <div className="px-6 py-2 text-xs font-bold text-slate-500 uppercase tracking-wider flex justify-between items-center cursor-pointer hover:text-slate-300" data-id="element-182">
            <div className="flex items-center gap-2" data-id="element-183">
              <div className="w-1.5 h-1.5 rounded-full bg-slate-600" data-id="element-184"></div>
              Why?
            </div>
            <ChevronDown size={14} data-id="element-185" />
          </div>
        </div>

        <div className="mb-6" data-id="element-186">
          <div className="px-6 py-2 text-xs font-bold text-slate-500 uppercase tracking-wider flex justify-between items-center cursor-pointer hover:text-slate-300" data-id="element-187">
            <div className="flex items-center gap-2" data-id="element-188">
              <div className="w-1.5 h-1.5 rounded-full bg-slate-600" data-id="element-189"></div>
              What's Next?
            </div>
            <ChevronDown size={14} data-id="element-190" />
          </div>
        </div>
      </div>

      <div className="p-6 text-xs text-slate-500" data-id="element-191">
        © 2026 RKD Group · Digital Intelligence
      </div>
    </div>;
}